export enum AtendimentosMensagensTypes {
  'SEND_MENSSAGE_REQUESTE' = '@sendMensagens/SEND_MENSSAGE_REQUEST',
  'SEND_MENSSAGE_SUCCESS' = '@sendMensagens/SEND_MENSSAGE_SUCCESS',
  'SEND_MENSSAGE_FAILURE' = '@sendMensagens/SEND_MENSSAGE_FAILURE',

  'CLEAR_MENSSAGE' = '@sendMensagens/CLEAR_MENSSAGE',
}
export interface Usuario {
  codUsu: number;
  nome: string;
  avatar: string;
}

export interface Messages {
  anexos: number;
  codUsu: number;
  dhInclusao: string;
  lido: boolean;
  seq: number;
  texto: string;
}
export interface MensagensOcorrencia {
  usuarios: Usuario[];
  mensagens: Messages[];
}

export interface Attachments {
  key: string;
  nome: string;
}

export interface AtendimentosMensagensState {
  readonly data: MensagensOcorrencia;
  readonly loading: boolean;
  readonly error: boolean;
}
